import Typography from "@portal/components/atoms/v2/typography";
import { OnAdvisorClick } from "../../handlers";
import { RadioGroup } from "@headlessui/react";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IAdvisorProps } from "../types";
import RadioComponentWithSelectionBox from "@portal/components/atoms/v2/radioComponentWithSelectionBox";

export const AdvisorOptions = ({ advisorCarriedOut, isDefaultLanguage, setSavingsAgreementAdvisorCarriedOut }: IAdvisorProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_16_A, texts.PAGE_16_B];

  const handleChange = (i: number) => {
    OnAdvisorClick(i, setSavingsAgreementAdvisorCarriedOut);
  };

  return (
    <div className="flex flex-col">
      <RadioGroup value={advisorCarriedOut ? 1 : 0} onChange={handleChange} className="space-y-3">
        {options.map((text, i) => (
          <RadioComponentWithSelectionBox key={i} value={i} id={i.toString()}>
            <div className="flex flex-col p-2">
              <Typography>{text}</Typography>
            </div>
          </RadioComponentWithSelectionBox>
        ))}
      </RadioGroup>
    </div>
  );
};
